import { Button, Dropdown, Icons } from '@commenda/kakashi';

import type { IComposerModelConfig } from './types';

interface ComposerModelMenuProps {
  modelConfig: IComposerModelConfig;
}

/** The model the next turn runs on, for a surface that offers a choice. */
export const ComposerModelMenu = ({ modelConfig }: ComposerModelMenuProps) => {
  const modelLabel =
    modelConfig.models.find((model) => model.id === modelConfig.modelId)
      ?.label ?? 'Model';

  if (modelConfig.isLoading || modelConfig.error) {
    return (
      <Button
        variant="tertiary"
        size="sm"
        disabled
        aria-busy={Boolean(modelConfig.isLoading)}
        title={
          modelConfig.error
            ? "Couldn't load the models. Refresh to try again."
            : undefined
        }
      >
        {modelConfig.isLoading ? 'Loading models…' : 'Models unavailable'}
      </Button>
    );
  }

  return (
    <Dropdown
      align="start"
      side="top"
      sideOffset={8}
      menu={{
        groups: [
          {
            items: modelConfig.models.map((model) => ({
              label: model.label,
              onClick: () => modelConfig.onModelChange(model.id),
            })),
          },
        ],
      }}
    >
      <Button variant="tertiary" size="sm">
        {modelLabel}
        <Icons.ChevronDown className="size-3" />
      </Button>
    </Dropdown>
  );
};
